import { createSelector } from 'reselect'

const getStore = state => state.store

const storeSelector = createSelector(
	[ getStore ],
	storeData => ({
		query: storeData.query,
		selectedFilters: storeData.selectedFilters.map(item => {
			if (item.indexOf('--C') !== -1) {
				return item.substr(0, item.indexOf('--C'))
			} else {
				return item
			}
		}),
	})
)

export default storeSelector
